var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { lighten } from "@mui/material/styles";
import { COLORS } from "../../../constants";
/**
 * styles for card action component
 */
export var cardActionStylesFn = function (_a) {
    var disabled = _a.disabled;
    return (__assign({ border: ["none", "21px"], ".MuiCardActionArea-focusHighlight": __assign({}, (!disabled ? { background: "none" } : {})) }, (disabled ? { cursor: "not-allowed" } : {})));
};
/**
 * styles added per custom rules outside of MUI Card
 */
var customCardStyleObject = {
    dragged: {
        backgroundColor: function (theme) {
            return "".concat(lighten(theme.palette.primary.main, 0.92));
        },
    },
    selected: {
        backgroundColor: function (theme) {
            return "".concat(lighten(theme.palette.primary.main, 0.92));
        },
    },
    disabled: {
        border: "solid 1px ".concat(COLORS.P_OUTLINE),
        cursor: "not-allowed",
    },
};
/**
 * main card styles
 */
export var cardStylesFn = function (_a) {
    var _b;
    var borderColor = _a.borderColor, variant = _a.variant, elevation = _a.elevation, hasHoverBg = _a.hasHoverBg, disabled = _a.disabled, selected = _a.selected, breakpoints = _a.breakpoints, dragged = _a.dragged, squareOnMobile = _a.squareOnMobile;
    return (__assign(__assign(__assign(__assign(__assign({ border: variant === "outlined" ? "1px solid ".concat(borderColor) : "inherit" }, (elevation === 24 && {
        boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 2px 1px -1px rgba(0, 0, 0, 0.12), 0 1px 1px 0 rgba(0, 0, 0, 0.14)",
    })), (_b = { "&::selection": {
                backgroundColor: "primary.main",
            } }, _b[breakpoints.down("sm")] = __assign({}, (squareOnMobile
        ? {
            border: "none",
            borderRadius: "0px",
            borderLeft: variant === "outlined" ? "2px solid ".concat(borderColor) : "inherit",
        }
        : {})), _b[breakpoints.up("sm")] = {
        "&:hover": {
            backgroundColor: function (theme) {
                return !disabled && hasHoverBg
                    ? "".concat(lighten(theme.palette.primary.main, 0.96))
                    : undefined;
            },
        },
    }, _b)), (dragged ? customCardStyleObject.dragged : {})), (disabled ? customCardStyleObject.disabled : {})), (selected ? customCardStyleObject.selected : {})));
};
